import { editPricingOfAccountWhatsappCampaign, getPricingOfAccountWhatsappCampaign, getPricingOfAccountWhatsapp2Campaign, editPricingOfAccountWhatsapp2Campaign } from "../types/account_campaign_pricing_whatsapp_types";

export const getPricingOfAccountWhatsappCampaignRequest = (payload, cb) => ({
  type: getPricingOfAccountWhatsappCampaign.GET_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_REQUEST,
  payload,
  cb,
});
export const getPricingOfAccountWhatsappCampaignSuccess = (payload) => ({
  type: getPricingOfAccountWhatsappCampaign.GET_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_SUCCESS,
  payload,
});
export const getPricingOfAccountWhatsappCampaignError = (payload) => ({
  type: getPricingOfAccountWhatsappCampaign.GET_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_ERROR,
  payload,
});

export const editPricingOfAccountWhatsappCampaignRequest = (payload, cb) => ({
  type: editPricingOfAccountWhatsappCampaign.EDIT_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_REQUEST,
  payload,
  cb,
});
export const editPricingOfAccountWhatsappCampaignSuccess = (payload) => ({
  type: editPricingOfAccountWhatsappCampaign.EDIT_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_SUCCESS,
  payload,
});
export const editPricingOfAccountWhatsappCampaignError = (payload) => ({
  type: editPricingOfAccountWhatsappCampaign.EDIT_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_ERROR,
  payload,
});



export const getPricingOfAccountWhatsapp2CampaignRequest = (payload, cb) => ({
  type: getPricingOfAccountWhatsapp2Campaign.REQUEST,
  payload,
  cb,
});
export const getPricingOfAccountWhatsapp2CampaignSuccess = (payload) => ({
  type: getPricingOfAccountWhatsapp2Campaign.SUCCESS,
  payload,
});
export const getPricingOfAccountWhatsapp2CampaignError = (payload) => ({
  type: getPricingOfAccountWhatsapp2Campaign.ERROR,
  payload,
});

export const editPricingOfAccountWhatsapp2CampaignRequest = (payload, cb) => ({
  type: editPricingOfAccountWhatsapp2Campaign.REQUEST,
  payload,
  cb,
});
export const editPricingOfAccountWhatsapp2CampaignSuccess = (payload) => ({
  type: editPricingOfAccountWhatsapp2Campaign.SUCCESS,
  payload,
});
export const editPricingOfAccountWhatsapp2CampaignError = (payload) => ({
  type: editPricingOfAccountWhatsapp2Campaign.ERROR,
});
